import { actionTypeConstants } from "../utils";

function notificationReducer(state = [] as any[], action = {} as any) {

  switch (action.type) {

    case actionTypeConstants.SHOW_MESSAGE:
      return [
        ...state,
        action.payload
      ]
    case actionTypeConstants.HIDE_MESSAGE:
      return state.filter((item) => item.id !== action.payload.id);
    default:
      return state;
  }
}

export default notificationReducer;
